import React from "react";
import { Route, Switch } from "react-router-dom";

import * as QueriesQL from "queries/table";
import TablePublicSchema from "@common/schema/table/public";
import * as Section from "@repoflow/components/section";
import { Crumb } from "@repoflow/components/breadcrumb";

import * as ViewRoute from "./view";
import * as RemoveRoute from "./remove";

const LocalProvider = ({
  match: {
    params,
    params: { tableId },
  },
  children: Children,
}) => {
  const { base: parentBase, basepath: parentBasepath } =
    Section.useSectionContext();

  const base = `${parentBase}/${tableId}`;
  const basepath = `${parentBasepath}/:tableId`;

  // Keyed on the entity. The screen below seeds its form state ONCE, from the
  // table this route resolved, so moving from one tableId to another has to
  // reset it — and since the render prop is called rather than rendered, that
  // reset is asked for here rather than arriving free from a remount.
  return (
    <Section.Provider
      key={tableId}
      schema={[...TablePublicSchema]}
      base={base}
      basepath={basepath}
      attributes={params}
    >
      {/* Called, never rendered as an element — see Section.Provider. */}
      {Children({ base, basepath, params })}
    </Section.Provider>
  );
};

export function Content(props) {
  return (
    <LocalProvider {...props}>
      {({ params }) => (
        <Section.Query
          // getWithRows, not get: this screen edits the rows, and the etag it
          // must condition its save on comes back in the same response as them.
          query={QueriesQL.getWithRows}
          variables={params}
          datapath={"tables.get"}
          fetchPolicy={"network-only"}
        >
          {ContentHandler}
        </Section.Query>
      )}
    </LocalProvider>
  );
}

function ContentHandler({ basepath }) {
  return (
    <Switch>
      <Route path={`${basepath}/remove`} component={RemoveRoute.Content} />
      <Route path={`${basepath}`} component={ViewRoute.Content} />
    </Switch>
  );
}

export function Indice(props) {
  return (
    <LocalProvider {...props}>
      {({ base, basepath, params: { tableId } }) => (
        <>
          <Crumb to={`${base}`} label={tableId} />

          <Switch>
            <Route path={`${basepath}/remove`} component={RemoveRoute.Indice} />
            <Route path={`${basepath}`} component={ViewRoute.Indice} />
          </Switch>
        </>
      )}
    </LocalProvider>
  );
}

export const Sidebar = () => (
  <>
    <ViewRoute.Sidebar />
  </>
);
